var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9871 0.0787397L1.04594 6.05922C0.465561 6.25269 0.0564625 6.77343 0.00523032 7.38364C-0.0452372 7.99385 0.272872 8.575 0.814251 8.86175L8.21845 12.7815L12.1389 20.1865C12.4248 20.7271 13.0068 21.0452 13.6162 20.9948C14.2264 20.9443 14.7479 20.5352 14.9413 19.954C16.2871 15.9173 19.6623 5.79082 20.9217 2.01335C21.1045 1.46356 20.9615 0.85794 20.5524 0.448077C20.1425 0.0382135 19.5369 -0.104781 18.9871 0.0787397ZM9.72483 12.357L13.49 19.4708L19.4704 1.52932L1.52996 7.50981L8.64283 11.2758L12.0287 7.88984C12.327 7.59162 12.8118 7.59162 13.11 7.88984C13.4082 8.18883 13.4082 8.67287 13.11 8.97186L9.72483 12.357Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.d4f1c5a015e9336bd36637b808255d88.svg";
export { ForwardRef as ReactComponent };